import { QrCodeTicketingDisplay, QrCodeTicketingDisplayLoader } from './QrCodeTicketingDisplay';


export const qrCodeTicketingRouter = {
  path: '/qr_code_ticketing/:uid',
  id: 'qrcodeTicketing',
  loader: QrCodeTicketingDisplayLoader,
  element: <QrCodeTicketingDisplay />,
};
